import React from 'react'

const Approach = () => {
  return (
    <section id='getstarted'>
      <div className="s-50"></div>
      <div className="container brd-white p-5">
        <h2 className="title-intro c-white">Get Started</h2>
        <div className="s-50"></div>
        <div className="row">
          <div className="col-lg-4 mb-4">
            <div className="brd-white px-5 py-5 flex jcc aic" style={{ minHeight: '200px' }}>
              <div className="form">
                <h3 className="title c-white">Discuss your project</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="brd-white px-5 py-5 flex jcc aic" style={{ minHeight: '200px' }}>
              <div className="form">
                <h3 className="title c-white">Define time & material</h3>
              </div>
            </div>
          </div>
          <div className="col-lg-4 mb-4">
            <div className="brd-white px-5 py-5 flex jcc aic" style={{ minHeight: '200px' }}>
              <div className="form">
                <h3 className="title c-white">Start Delivery in two weeks</h3>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export { Approach }
